import { zoningLegendStyles } from './styles.js';
// Zoning colors matching v1 and Map.ts
const ZONING_COLORS = {
    'Residential': '#34d399',
    'Apartment': '#8b5cf6',
    'Apartment*': '#f59e0b',
    'Hotel': '#3b82f6',
};
const ZONING_DESCRIPTIONS = {
    'Residential': 'R-1, R-2, R-3 zones.',
    'Apartment': 'A-1, A-2 zones.',
    'Apartment*': 'Minatoya List properties.',
    'Hotel': 'H-1, H-2, H-M zones.',
};
// STR = short-term rental. 'Apartment*' (Minatoya List) is TBD, not a flat
// yes/no - see the note appended below the table in showInfoPopup().
const STR_ALLOWED = {
    'Hotel': 'Yes',
    'Apartment*': 'TBD',
    'Apartment': 'No',
    'Residential': 'No',
};
const MINATOYA_NOTE = 'These properties currently allow short term rentals (STR), but are on the "Minatoya List." They are scheduled to phase out STR beginning January 1, 2029 in West Maui and January 1, 2031 elsewhere. The County has created H-3/H-4 hotel zoning and is discussing property-by-property rezoning that could allow some of the affected units to continue operating as short-term rentals. You should discuss this with a real-estate agent.';
export class ZoningLegend {
    container;
    legendEl = null;
    visible = false;
    categoryVisibility = {
        'Residential': true,
        'Apartment': true,
        'Apartment*': true,
        'Hotel': true,
    };
    onCategoryToggle;
    constructor(options) {
        this.container = options.container;
        this.onCategoryToggle = options.onCategoryToggle;
        this.injectStyles();
        this.render();
    }
    injectStyles() {
        if (document.getElementById('zoning-legend-styles'))
            return;
        const style = document.createElement('style');
        style.id = 'zoning-legend-styles';
        style.textContent = zoningLegendStyles;
        document.head.appendChild(style);
    }
    render() {
        this.legendEl = document.createElement('div');
        this.legendEl.className = 'zoning-legend';
        this.legendEl.innerHTML = `
      <div class="zoning-legend-header">
        <span class="zoning-legend-title">Zoning</span>
        <button type="button" class="zoning-info-btn" title="What do these mean?">?</button>
      </div>
      ${this.renderCategories()}
    `;
        // Add event listeners
        this.legendEl.querySelector('.zoning-info-btn')?.addEventListener('click', () => {
            this.showInfoPopup();
        });
        this.legendEl.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
            checkbox.addEventListener('change', (e) => {
                const target = e.target;
                const category = target.dataset.category;
                const visible = target.checked;
                this.categoryVisibility[category] = visible;
                // Update item styling
                const item = target.closest('.zoning-legend-item');
                item?.classList.toggle('disabled', !visible);
                this.onCategoryToggle?.(category, visible);
            });
        });
        this.container.appendChild(this.legendEl);
    }
    renderCategories() {
        const categories = ['Residential', 'Apartment', 'Apartment*', 'Hotel'];
        return categories.map(category => `
      <label class="zoning-legend-item" data-category="${category}">
        <input type="checkbox" data-category="${category}" checked>
        <div class="zoning-legend-color" style="background: ${ZONING_COLORS[category]};"></div>
        <span class="zoning-legend-label">${category}</span>
      </label>
    `).join('');
    }
    showInfoPopup() {
        const overlay = document.createElement('div');
        overlay.className = 'zoning-info-overlay';
        const popup = document.createElement('div');
        popup.className = 'zoning-info-popup';
        popup.innerHTML = `
      <button class="close-btn">&times;</button>
      <h3>Maui Zoning Categories</h3>
      <p>Zoning determines whether short-term vacation rentals (STR) are permitted:</p>
      <table class="zoning-info-table">
        <thead>
          <tr><th></th><th>Category</th><th>Zone</th><th>STR</th></tr>
        </thead>
        <tbody>
          ${['Hotel', 'Apartment*', 'Apartment', 'Residential'].map(category => `
            <tr>
              <td><div class="category-color" style="background: ${ZONING_COLORS[category]};"></div></td>
              <td><strong>${category}</strong></td>
              <td>${ZONING_DESCRIPTIONS[category]}</td>
              <td class="str-${STR_ALLOWED[category].toLowerCase()}">${STR_ALLOWED[category]}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      <p class="minatoya-note"><strong>Apartment*</strong> (Minatoya List): ${MINATOYA_NOTE}</p>
    `;
        const close = () => {
            overlay.remove();
            popup.remove();
        };
        overlay.addEventListener('click', close);
        popup.querySelector('.close-btn')?.addEventListener('click', close);
        document.body.appendChild(overlay);
        document.body.appendChild(popup);
    }
    show() {
        this.visible = true;
        this.legendEl?.classList.add('visible');
    }
    hide() {
        this.visible = false;
        this.legendEl?.classList.remove('visible');
    }
    toggle(show) {
        if (show === undefined) {
            show = !this.visible;
        }
        if (show) {
            this.show();
        }
        else {
            this.hide();
        }
    }
    isVisible() {
        return this.visible;
    }
    getCategoryVisibility() {
        return { ...this.categoryVisibility };
    }
    destroy() {
        this.legendEl?.remove();
        document.getElementById('zoning-legend-styles')?.remove();
    }
}
//# sourceMappingURL=ZoningLegend.js.map